import { TimeoutError } from 'rxjs';
import { catchError, timeout as timeoutOperator } from 'rxjs/operators';
/**
 * Add a timeout to given observable
 */
export function timeoutObservable(obs, timeout, errorFactory) {
    if (timeout) {
        obs = obs.pipe(timeoutOperator(timeout), catchError((err) => {
            if (errorFactory && err instanceof TimeoutError) {
                throw errorFactory(err);
            }
            throw err;
        }));
    }
    return obs;
}
